import { lazy } from 'react';
import { ShoppingCartOutlined } from '@ant-design/icons';
import { appConstants, roleConstants, commonConstants } from 'constants/index';
import { DPOS_PATHS } from 'constants/paths';
import { tLazy } from 'helpers/i18n';
import { getSrc } from 'helpers/url';
import { commonHelpers } from 'helpers';
import configHelpers from 'helpers/config';

const { getCommonConfig } = configHelpers;
const { baseDposUrl, baseSposUrl } = getCommonConfig();

const { STAFF_BFF } = appConstants;
const { SHOPPING_CART_STAFF, SHOPPING_CART_MARKETPLACE_STAFF } = roleConstants;
const { BROWSER_PERMISSIONS } = commonConstants;
const { permission } = commonHelpers;

// Pages
const IFrameContainer = lazy(() => import('containers/shared/IFrameContainer'));

/*
 * If route has children, it's a parent menu (not link to any pages)
 */
const dposRoutes = [
  // Parent menu
  {
    path: '/dpos',
    name: tLazy('DPOS.Root'),
    nameTransKey: 'DPOS.Root',
    icon: ShoppingCartOutlined,
    children: [
      '/dpos/create-order',
      '/dpos/create-marketplace-order',
      '/dpos/end-shift',
      '/dpos/end-shift-history',
      '/dpos/orders',
    ],
  },
  // Sub menus
  {
    exact: true,
    path: '/dpos/create-order',
    name: tLazy('DPOS.CreateOrder'),
    component: IFrameContainer,
    iFrameSrc: getSrc(baseDposUrl),
    permissions: [permission(STAFF_BFF, SHOPPING_CART_STAFF)],
    usePermissionPrefix: true,
    hideBreadcrumb: true,
    hideTitle: true,
    supportOfflineMode: true,
    browserPermissions: [BROWSER_PERMISSIONS.NOTIFICATIONS],
  },
  {
    exact: true,
    path: '/dpos/create-marketplace-order',
    name: tLazy('DPOS.CreateMarketplaceOrder'),
    component: IFrameContainer,
    iFrameSrc: getSrc(baseDposUrl),
    permissions: [permission(STAFF_BFF, SHOPPING_CART_MARKETPLACE_STAFF)],
    usePermissionPrefix: true,
    hideBreadcrumb: true,
    hideTitle: true,
    browserPermissions: [BROWSER_PERMISSIONS.NOTIFICATIONS],
  },
  {
    exact: true,
    path: '/dpos/end-shift',
    name: tLazy('DPOS.EndShift'),
    component: IFrameContainer,
    iFrameSrc: getSrc(baseDposUrl, DPOS_PATHS.EndShift),
    permissions: [permission(STAFF_BFF, SHOPPING_CART_STAFF)],
    usePermissionPrefix: true,
    hideBreadcrumb: true,
    hideTitle: true,
  },
  {
    exact: true,
    path: '/dpos/end-shift-history',
    name: tLazy('DPOS.EndShiftHistory'),
    component: IFrameContainer,
    iFrameSrc: getSrc(baseSposUrl, DPOS_PATHS.EndShiftHistory),
    permissions: [permission(STAFF_BFF, SHOPPING_CART_STAFF)],
    usePermissionPrefix: true,
    hideBreadcrumb: true,
    hideTitle: true,
    isModalItem: true,
  },
  {
    exact: true,
    path: '/dpos/orders',
    name: tLazy('DPOS.Orders'),
    component: IFrameContainer,
    iFrameSrc: getSrc(baseDposUrl, DPOS_PATHS.Orders),
    permissions: [permission(STAFF_BFF, SHOPPING_CART_STAFF)],
    usePermissionPrefix: true,
    hideBreadcrumb: true,
    hideTitle: true,
    browserPermissions: [BROWSER_PERMISSIONS.NOTIFICATIONS],
  },
  {
    exact: true,
    path: '/dpos/order-result',
    name: tLazy('DPOS.OrderResult'),
    component: IFrameContainer,
    iFrameSrc: getSrc(baseDposUrl, DPOS_PATHS.OrderResult),
    permission: [permission(STAFF_BFF, SHOPPING_CART_STAFF)],
    usePermissionPrefix: true,
    hideBreadcrumb: true,
    hideTitle: true,
    supportOfflineMode: true,
    browserPermissions: [BROWSER_PERMISSIONS.NOTIFICATIONS],
  },
  {
    exact: true,
    path: '/dpos/clone-order',
    name: tLazy('DPOS.CloneOrder'),
    component: IFrameContainer,
    iFrameSrc: getSrc(baseDposUrl, DPOS_PATHS.CloneOrder),
    permissions: [permission(STAFF_BFF, SHOPPING_CART_STAFF)],
    usePermissionPrefix: true,
    hideBreadcrumb: true,
    hideTitle: true,
  },
];

export default dposRoutes;
